<!-- 已持有列表-->
<template>
  <div>
    <div class="fromBox boxShadow">
      <!-- <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane  v-for="(item, index) in menuList" :key="index" :label="item.menuName" :name="item.routerName"></el-tab-pane>
      </el-tabs> -->
      <el-tabs type="card" v-model="activeName" @tab-click="handleClick">
        <el-tab-pane
          v-for="(item, index) in tabList"
          :key="index"
          :name="item.path"
        >
          <span slot="label">
            <i class="el-icon-date"></i>{{ item.menuName }}
          </span>
        </el-tab-pane>
      </el-tabs>
      <router-view :key="Akey"></router-view>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Search from "@/components/public/Element/formSearch.vue";
import Rectangle from "@/components/public/Element/rectangle.vue";
import TipsLabel from "@/components/public/Element/tipsLabel.vue";
import icon_qrtj from "@/assets/img/supplier/mainPage-standReceived/icon_qrtj@2x.png";
import buttonSel from "@/components/public/Element/ElNormalButton.vue";
import Table from "@/components/public/Element/ElTable.vue";
export default {
  components: {
    Search,
    Rectangle,
    TipsLabel,
    Table,
    buttonSel,
  },
  data() {
    return {
      icon_qrtj,
      loading: false,
      count: "0",
      secBizScence: "1",
      totalVoucherAmount: "0",
      activeName: "888",
      centerDialogVisible2: false,
      currVoucherNo: "",
      Akey: "",
      menuList: [
        {
          menuName: " 自动签收",
          routerName: "sup-all-pos-auto",
          class: "el-icon-date",
        },
        {
          menuName: " 已签收",
          routerName: "sup-all-pos-sign",
          class: "el-icon-date",
        },
        {
          menuName: " 融资中",
          routerName: "sup-all-pos-financing",
          class: "el-icon-date",
        },
        {
          menuName: " 转单中",
          routerName: "sup-all-pos-transfing",
          class: "el-icon-date",
        },
        {
          menuName: " 现金折扣中",
          routerName: "sup-all-pos-cash",
          class: "el-icon-date",
        },
        {
          menuName: " 清分中",
          routerName: "sup-all-pos-distributing",
          class: "el-icon-date",
        },
      ],
    };
  },
  computed: {
    ...mapGetters(["secondaryMenu", "dynamicMenu"]),
    tabList() {
      if (this.dynamicMenu === "ON") {
        // 开启动态菜单，则二级菜单取store中的数据
        let temp = {};
        for (let j = 0; j < this.secondaryMenu.length; j++) {
          if ("已持有列表" == this.secondaryMenu[j].menuName) {
            temp = this.secondaryMenu[j];
          }
        }
        // let newArr = []
        // newArr = JSON.parse(JSON.stringify(temp.children))
        // newArr.push({
        //   path: 'sup-all-pos-distributing',
        //   menuName: '清分中'
        // })
        // console.log('temp44',newArr)
        // return newArr;
        return temp.children
      } else {
        return this.menuList;
      }
    },
  },
  created() {
    if (this.$route.name) {
      this.activeName = this.$route.name;
      console.log(">>>>>>>>>>.", this.activeName);
    } else {
      this.activeName = "sup-all-pos-auto";
    }
  },
  watch: {
    $route(to, from) {
      //解决刷新后部跳转问题
      // let arr = to.name;
      // this.currRouter(arr);
      let arr = [
        "sup-all-pos-auto",
        "sup-all-pos-sign",
        "sup-all-pos-financing",
        "sup-all-pos-transfing",
        "sup-all-pos-cash",
        "sup-all-pos-distributing",
      ];
      if (arr.includes(to.name)) {
        this.Akey = to.name;
      }
      console.log("路由改变", this.Akey);
    },
    deep: true,
  },
  methods: {
    handleDetailPage(val) {
      let voucherNo = val.voucherNo;
      this.$router.push({
        path: "/SupplierMainPage/requestFinancing/dChainDetail",
        query: { id: voucherNo },
      });
    },

    handleClick(tab, event) {
      console.log(tab.name);
      // this.name =
      let from = this.$route.name;
      if (from != this.activeName) {
        console.log("1111111111111", this.activeName);
        this.$router.push({
          name: this.activeName,
        });
      }
    },
  },
};
</script>

<style lang="less" scoped>
.fromBox {
  /deep/.el-tabs__item {
    padding: 0 14px;
  }
  /deep/.el-tabs__item.is-active {
    color: var(--color-high-background);
    // background: #ecf5ff;
    background: rgb(201, 215, 255);
    border-radius: 2px;
  }
  /deep/.el-tabs__item.is-top:nth-child(2),
  /deep/.el-tabs__item.is-top:last-child {
    padding: 0 14px;
  }
  /deep/.el-tabs__active-bar {
    background-color: var(--color-high-background);
    display: none;
  }
}
/deep/.el-tabs--card>.el-tabs__header .el-tabs__item,
/deep/.el-tabs--card>.el-tabs__header .el-tabs__nav {
  border: none;
}
.container-bottom-action {
  justify-content: space-between;
  .container-bottom-action-right {
    .right-button {
      height: 35px;
      text-align: center;
      color: #1b5bbf;
      font-size: 16px;
      border: 1px solid #1b5bbf;
    }
  }
}

.tableBox {
  margin-top: 13px;
  padding-top: 13px;
  padding: 16px 48px 0px;
  background-color: #fff;
  min-height: 400px;

  .tip {
    margin-top: 12px;
    margin-bottom: 18px;
    line-height: 1.5;
  }
}
</style>